import { proxy, subscribe } from "valtio"
import { derive } from "valtio/utils"

// function init() {
//   let flag = localStorage.getItem("personPlay")
//   if (!flag) {
//     localStorage.setItem(
//       "personPlay",
//       JSON.stringify({
//         playObj: {
//           id: "",
//           picUrl: "",
//           name: "",
//           siname: "",
//           sinameId: "",
//           singer: [],
//           dt: "",
//           url: ""
//         },
//         pbFlag: false,
//         pbList: []
//       })
//     )
//   }
// }
// init()
const personPlaySetup = proxy(
  JSON.parse(localStorage.getItem("personPlay"))
    ? JSON.parse(localStorage.getItem("personPlay"))
    : {
        curSheet: 0, // 当前歌单
        personSongList: [] // 当前歌曲列表
      }
)
// 设置当前歌曲列表
const setPersonSongList = (val) => {
  personPlaySetup.personSongList = val
}
// 类似于计算属性
const derived = derive({
  personSongList: () => personPlaySetup.personSongList
})
subscribe(personPlaySetup, () => {
  console.log("personPlaySetup1111", personPlaySetup)
  localStorage.setItem("personPlay", JSON.stringify(personPlaySetup))
})

export { setPersonSongList, derived }

export default personPlaySetup

//valtio-persist 数据持久化可以看一下这个库（目前还未使用）
